import React, {useRef} from 'react';
import {connect} from "react-redux";
import SqftNavAside from "../../components/navigation/SqftNavAside";
import SqftNavAside2 from "../../components/navigation/SqftNavAside2";
import SqftNavAsideCabinet from "./SqftNavAsideCabinet";
import SqftNavigationCabinet from "./menu/cabinet/SqftToolMenuCabinet";
import SqftNavigation from "./menu/countertop/SqftToolMenuCountertop";
import SqftNavShapes from "./menu/countertop/toolMenu/SqftNavShapes";
import SqftNavLayouts from "./menu/countertop/toolMenu/SqftNavLayouts";
import SqftNavSummary from "./menu/SqftNavSummary";
import SqftNavEdges from "./menu/countertop/toolMenu/SqftNavEdges";
import SqftNavAppliances from "./menu/commonTools/SqftNavAppliances";
import SqftNavBumpouts from "./menu/countertop/toolMenu/SqftNavBumpouts";
import SqftNavBacksplashes from "./menu/countertop/toolMenu/SqftNavBacksplashes";
import SqftNavCorners from "./menu/countertop/toolMenu/SqftNavCorners";
import SqftNavigationUpper from "./menu/cabinet/toolMenu/SqftNavigationUpper";
import SqftNavigationBottom from "./menu/cabinet/toolMenu/SqftNavigationBottom";
import SqftNavigationCrownMolding from "./menu/cabinet/toolMenu/SqftNavigationCrownMolding";
import SqftNavFeatures from "./menu/commonTools/SqftNavFeatures";
import SqftNavAsideSlabMode from "./SqftNavAsideSlabMode";
import SqftNavSeam from "./menu/slab/toolMenu/SqftNavSeam";
import SqftNavMitered from "./menu/countertop/toolMenu/SqftNavMitered";
import SqftNavUnderlayment from "./menu/countertop/toolMenu/SqftNavUnderlayment";
import SqftNavWaterfall from "./menu/countertop/toolMenu/SqftNavWaterfall";
import {getIsSFTAreaGroup, isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";
import SqftNavigationTall from "./menu/cabinet/toolMenu/SqftNavigationTall";
import SqftNavFiltersMenu from "./menu/cabinet/filterMenu/SqftNavFiltersMenu";
import SqftNavFeaturesGrid from "./menu/commonTools/featuresGrid/SqftNavFeaturesGrid";
import SqftNavCustomBacksplashes from "./menu/countertop/toolMenu/toolBacksplash/SqftNavCustomBacksplashes";
import NavigationSidebarSecondRow from "./NavigationSidebarSecondRow";

const NavigationSidebar = (props) => {
  // other popups, modals and so on
  const {activeButton, isShowSlabTool} = props;
  const isCabinet = isSFTCabinetsGroup();
  const isSFTAreaGroup = getIsSFTAreaGroup();
  const navRef = useRef(null);

  const navAside = () => {
    return isCabinet ? <SqftNavAsideCabinet />
      : isShowSlabTool
        ? <SqftNavAsideSlabMode/>
        : <SqftNavAside sqftGroup={isSFTAreaGroup}/>
  }

  return (
    <div>
      <div ref={navRef} className="sqft-nav">
        {
          navAside()
        }
        <SqftNavAside2/>
        { isCabinet ? <SqftNavigationCabinet/> : <SqftNavigation/> }
        <SqftNavShapes/>
        { !isSFTAreaGroup ? <SqftNavLayouts/> : null}
        <SqftNavSummary/>
        <SqftNavEdges/>
        <SqftNavFeaturesGrid/>
        <SqftNavAppliances/>
        <SqftNavBacksplashes/>
        <SqftNavCustomBacksplashes/>
        <SqftNavCorners/>
        <SqftNavBumpouts/>
        <SqftNavSeam/>
        <SqftNavMitered/>
        <SqftNavUnderlayment/>
        <SqftNavWaterfall/>
        { isCabinet ? <SqftNavigationUpper/> : null }
        { isCabinet ? <SqftNavigationBottom/> : null }
        { isCabinet ? <SqftNavigationTall/> : null }
        { isCabinet ? <SqftNavigationCrownMolding/> : null }
        { isCabinet ? <SqftNavFeatures/> : null }
        { isCabinet ? <SqftNavFiltersMenu/> : null }
      </div>
      <NavigationSidebarSecondRow
        parentRef={navRef}
        isCabinet={isCabinet}
        activeButton={activeButton}
      />
    </div>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSidebar);
